import type { HubConnection } from '@microsoft/signalr';
import { useEffect, useRef } from 'react';

export const useWebsocketEvent = <T>(
  connection: HubConnection,
  event: string,
  callback: (args: T) => void
) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const handler = (args: T) => callbackRef.current(args);
    connection.on?.(event as string, handler);
    return () => {
      connection.off(event as string, handler);
    };
  }, [connection, event]);
};
